module.exports = __webpack_public_path__ + "img/sidebar-toggle-on.0be5c381.svg";